const routes = {
  settings: () => `/settings`,

  collections: () => `/collections`,
  collection: (slug: string) => `/collections/${slug}`,

  items: () => `/items`,
  item: (slug: string) => `/items/${slug}`,

  organization: (id: string) => `/organisations/${id}`,
  organizationCreate: (id: string) => `/organisations/create`,

  stripeOnboarding: (id: string) => `/organisations/${id}/stripe/onboarding`,

  payBid: (id: string) => `/pay/bids/${id}`,
  payBidComplete: (id: string) => `/pay/bids/${id}/complete`,
};

export default routes;
